import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap, throwError } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IBed } from "./ibed";


@Injectable({ providedIn: 'root' })
export class BedService {

    private _bed: BehaviorSubject<IBed | null> = new BehaviorSubject<IBed | null>(null);
    private _beds: BehaviorSubject<IBed[]> = new BehaviorSubject<IBed[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get bed$(): Observable<IBed | null> {
        return this._bed.asObservable();
    }

    get beds$(): Observable<IBed[]> {
        return this._beds.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllBeds(bed: PaginationRequest & { roomId?: number | null }): Observable<BaseRespone<{ pagination: PaginationResult; bedDetails: IBed[] }>> {
        const requestBody = { ...bed };

        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; bedDetails: IBed[] }>>(`${environment.baseURl}/Bed/list`, requestBody).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._beds.next(response.result.bedDetails);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createBed(bedDetails: IBed): Observable<BaseRespone<IBed>> {
        return this._httpClient.post<BaseRespone<IBed>>(`${environment.baseURl}/Bed`, bedDetails)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteBed(id: number): Observable<BaseRespone<boolean>> {
        return this.beds$.pipe(
            take(1),
            switchMap(beds =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Bed/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = beds.filter(item => item.id !== id);
                            this._beds.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateBed(bedDetails: IBed): Observable<BaseRespone<IBed>> {
        return this.beds$.pipe(
            take(1),
            switchMap(beds => this._httpClient.put<BaseRespone<IBed>>(`${environment.baseURl}/Bed`, bedDetails).pipe(
                map((updated: BaseRespone<IBed>) => {
                    // Find the index of the updated product
                    const index = beds.findIndex(item => item.id === bedDetails.id);

                    // Update the product
                    beds[index] = bedDetails;

                    // Update the products
                    this._beds.next(beds);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }
}